import "F:\\Lee\\Desktop\\0206\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "F:\\Lee\\Desktop\\0206\\node_modules\\core-js\\modules\\es.promise.js";
import "F:\\Lee\\Desktop\\0206\\node_modules\\core-js\\modules\\es.object.assign.js";
import "F:\\Lee\\Desktop\\0206\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import text from '@/assets/text';
import '@/plugins/element';
import '@/assets/js/phone';
Vue.config.productionTip = false;
import scroll from 'vue-seamless-scroll';
Vue.use(scroll);
Vue.prototype.$text = text; // 滚动动画 wow.js

import 'wowjs/css/libs/animate.css';
import 'hover.css';
Vue.filter('substrLast', function (v) {
  return v ? v.substring(0, v.length - 9) : '';
});
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
Vue.component(CollapseTransition.name, CollapseTransition); // 动态修改meta搜索引擎

import Meta from 'vue-meta';
Vue.use(Meta, {
  refreshOnceOnNavigation: true
});

Vue.prototype.$scrollTo = function () {
  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'smooth';
  window.scrollTo({
    top: x,
    left: y,
    behavior: type // 滚动行为：smooth平滑滚动，instant瞬间滚动，默认值auto，等同于instant

  });
};

var app = new Vue({
  router: router,
  store: store,
  beforeCreate: function beforeCreate() {
    Vue.prototype.$bus = this;
  },
  // data: {
  //   title: 'How to use vue-meta',
  //   keywords: 'vue,vue-router,vue-meta',
  //   description: 'this is a des info.'
  // },
  // // 定义metaInfo
  // metaInfo() {
  //   return {
  //     title: this.title,
  //     meta: [
  //       {
  //         name: 'keywords',
  //         content: this.keywords
  //       }, {
  //         name: "description",
  //         content: this.description
  //       }
  //     ]
  //   }
  // },
  render: function render(h) {
    return h(App);
  }
});
app.$mount('#app');